import { H_Container, headerVariants } from "./Header.styled";
import { Logotype } from "./Logotype/Logotype";
import { Modules } from "./Modules/Modules";

interface HeaderProps {}

export const Header = ({}: HeaderProps) => {
	return (
		<H_Container variants={headerVariants}>
			<Logotype />
			<Modules />
		</H_Container>
	);
};
